import HarvestDashboardContainer from './containers/HarvestDashboardContainer';

export default HarvestDashboardContainer;
